import * as React from 'react';
import { CheckCircle2, Loader2, XCircle } from 'lucide-react';
import type { SendingStatus } from '../types';

interface StatusIconProps {
  status: SendingStatus;
}

export const StatusIcon: React.FC<StatusIconProps> = ({ status }) => {
  switch (status) {
    case 'success':
      return (
        <CheckCircle2 className="text-success-subtle-foreground h-4 w-4" />
      );
    case 'loading':
      return (
        <Loader2 className="text-info-subtle-foreground h-4 w-4 animate-spin" />
      );
    case 'error':
      return <XCircle className="text-error-subtle-foreground h-4 w-4" />;
    default:
      return null;
  }
};
